import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative z-20 mb-5" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkImageComponent = _resolveComponent("NetworkImageComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.campaign.profile.brandLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "block",
          href: _ctx.campaign.profile.brandLink,
          target: "_blank"
        }, [
          _createVNode(_component_NetworkImageComponent, {
            class: "w-24 h-24 xs:w-36 xs:h-36 mx-auto border-creation-on-background border-opacity-creation-low border rounded-full object-cover",
            image: _ctx.image,
            width: 300,
            height: 300,
            placeholder: "/assets/img/avatar-square.jpg",
            alt: _ctx.campaign.profile.url
          }, null, 8, ["image", "alt"])
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_NetworkImageComponent, {
            class: "w-24 h-24 xs:w-36 xs:h-36 mx-auto border-creation-on-background border-opacity-creation-low border rounded-full object-cover",
            image: _ctx.image,
            width: 300,
            height: 300,
            placeholder: "/assets/img/avatar-square.jpg",
            alt: _ctx.campaign.profile.url
          }, null, 8, ["image", "alt"])
        ]))
  ]))
}